import { Domain } from "@/types/domain";

export const upstreamDomains: Domain[] = [
  {
    symbol: "Egph",
    name: "Exploration Geophysics",
    categories: "Seismic Data Interpretation, Remote Sensing, Geophysical Modeling, Gravity/Magnetic Surveys"
  },
  {
    symbol: "Resv",
    name: "Reservoir Engineering",
    categories: "Reservoir Simulation, Enhanced Oil Recovery, PVT Analysis, Reservoir Characterization"
  },
  {
    symbol: "Dril",
    name: "Drilling Engineering",
    categories: "Well Design, Drilling Fluids, Blowout Prevention, Directional Drilling"
  },
  {
    symbol: "Prod",
    name: "Production Engineering",
    categories: "Well Completion, Artificial Lift Systems, Production Optimization, Flow Assurance"
  },
  {
    symbol: "Subs",
    name: "Subsurface Data Management",
    categories: "Seismic Data Storage, Reservoir Data, 3D Modeling, Data Standards"
  },
  {
    symbol: "Hsaf",
    name: "HSE Standards",
    categories: "Environmental Assessments, Safety Regulations, Oil Spill Protocols, Risk Management"
  },
  {
    symbol: "Schn",
    name: "Supply Chain Management",
    categories: "Supply Chain Optimization, Offshore Logistics, Vendor Contracting, Procurement"
  },
  {
    symbol: "Peco",
    name: "Petroleum Economics",
    categories: "Economic Models, Price Forecasting, Risk Management, Profitability Metrics"
  },
  {
    symbol: "Offs",
    name: "Offshore Engineering",
    categories: "Subsea Engineering, Platform Design, Deepwater Drilling, Offshore Construction"
  },
  {
    symbol: "Regs",
    name: "Regulatory Compliance",
    categories: "Lease Management, Environmental Compliance, Government Reporting, Drilling Regulations"
  },
  {
    symbol: "Aiog",
    name: "AI in Oil and Gas",
    categories: "AI Seismic Interpretation, Predictive Maintenance, Drilling Optimization, Production Forecasting"
  },
  {
    symbol: "Watr",
    name: "Water Management",
    categories: "Water Treatment, Recycling, Produced Water Management, Hydraulic Fracturing Efficiency"
  },
  {
    symbol: "Carb",
    name: "Carbon Capture & Storage",
    categories: "CO2 Sequestration, Storage Monitoring, CCS Economics, Regulatory Frameworks"
  },
  {
    symbol: "Frac",
    name: "Hydraulic Fracturing",
    categories: "Fracture Design, Fluid Selection, Microseismic Monitoring, Environmental Impact"
  },
  {
    symbol: "Digi",
    name: "Digital Oilfields",
    categories: "Real-time Monitoring, IoT, Predictive Analytics, Remote Operations"
  }
];